import axios from 'axios';
import { MNSproCloudApi } from '..';
import {
  BasicMdmGroupResponse,
  BasicSoftwareResponse,
  InstallStatus,
  MdmGroupCreateEntry,
  MdmGroupResponse,
  MdmGroupUpdateEntry,
  PaginatedOfBasicMdmGroupResponse,
} from '../api/v2';

const getApi = (authToken: string) => {
  const config = MNSproCloudApi.V2.createConfiguration(authToken);
  const api = MNSproCloudApi.V2.MdmApiFactory(config);

  return api;
};

export class MDMGroupService {
  static async getAllGroups(
    organizationId: string,
    authToken: string,
  ): Promise<BasicMdmGroupResponse[]> {
    const api = getApi(authToken);

    const response = await api.getAllBasicMdmGroups(
      organizationId,
      undefined,
      undefined,
      10,
    );
    let nextLink: string | null | undefined = response.data.nextLink;
    let mdmGroups: BasicMdmGroupResponse[] = response.data.value;
    while (nextLink) {
      const pageResponse = await axios.get<PaginatedOfBasicMdmGroupResponse>(
        nextLink,
        {
          headers: {
            authorization: 'Bearer ' + authToken,
          },
        },
      );
      mdmGroups = mdmGroups.concat(pageResponse.data.value);
      nextLink = pageResponse.data.nextLink;
    }
    return mdmGroups;
  }

  static async getMDMGroup(
    organizationId: string,
    groupId: string,
    authToken: string,
  ): Promise<MdmGroupResponse> {
    const api = getApi(authToken);
    const response = await api.getMdmGroup(groupId, organizationId);

    return response.data;
  }

  static async deleteMDMGroup(
    organizationId: string,
    groupId: string,
    authToken: string,
  ): Promise<boolean> {
    const api = getApi(authToken);
    const response = await api.deleteMdmGroup(organizationId, groupId);

    return true;
  }

  static async createMDMGroup(
    organizationId: string,
    mdmGroup: MdmGroupCreateEntry,
    authToken: string,
  ): Promise<MdmGroupResponse> {
    const api = getApi(authToken);
    const response = await api.createMdmGroup(organizationId, mdmGroup);

    return response.data;
  }

  static async updateMDMGroup(
    organizationId: string,
    mdmGroup: MdmGroupUpdateEntry,
    softwareToRemove: BasicSoftwareResponse[],
    softwareToAdd: BasicSoftwareResponse[],
    authToken: string,
  ): Promise<MdmGroupResponse> {
    const api = getApi(authToken);
    const response = await api.updateMdmGroup(organizationId, mdmGroup);

    softwareToRemove.forEach(async element => {
      await api.assignSoftware(
        organizationId,
        [{ groupId: mdmGroup.id, intent: InstallStatus.uninstall }],
        element.id,
      );
    });

    softwareToAdd.forEach(async element => {
      await api.assignSoftware(
        organizationId,
        [{ groupId: mdmGroup.id, intent: InstallStatus.required }],
        element.id,
      );
    });

    return response.data;
  }
}
